import { Link } from 'react-router-dom';
import type { StateResponse } from '../domain';
import { FAULT_SEVERITY, faultLabel, type FaultKind } from '../domain/faults';

type Floor = 'ground' | 'middle' | 'top';

const FLOOR_LABEL: Record<Floor, string> = {
  ground: 'Ground Floor',
  middle: 'Middle Floor',
  top: 'Top Floor',
};

const CALL_LABEL: Record<'none' | 'heat' | 'cool', string> = {
  none: 'satisfied',
  heat: 'calling heat',
  cool: 'calling cool',
};

export function FloorCard({
  floor,
  state,
}: {
  floor: Floor;
  state: StateResponse['floors'][Floor];
}) {
  return (
    <div className="card">
      <Link to={`/floors/${floor}`} style={{ color: 'inherit', textDecoration: 'none', display: 'block' }}>
        <div className="card-header">
          <strong>{FLOOR_LABEL[floor]}</strong>
          <span className={`tag ${state.call}`}>{CALL_LABEL[state.call]}</span>
        </div>
        <div className={`reading ${state.in_safe_state ? 'safe-state' : ''}`}>
          {state.reading_c.toFixed(1)} °C
        </div>
        <div style={{ color: 'var(--muted)', fontSize: 14 }}>
          target {state.setpoint_effective_c.toFixed(1)} °C
          {state.in_safe_state ? ' · SAFE STATE' : ''}
        </div>
        {state.active_faults.length > 0 && (
          <div style={{ display: 'flex', flexWrap: 'wrap', gap: 'var(--sp-2)', marginTop: 'var(--sp-2)' }}>
            {state.active_faults.map((kind) => (
              <span key={kind} className={`tag ${FAULT_SEVERITY[kind as FaultKind] ?? 'warning'}`}>
                {faultLabel(kind)}
              </span>
            ))}
          </div>
        )}
      </Link>
    </div>
  );
}
